<template>
  <span>{{ address }}</span>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'b-table-address',
  props: {
    addressId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      address: ''
    }
  },
  created() {
    this.addressRow()
  },
  methods: {
    ...mapActions({
      getAddress: 'address/GET_ADDRESS_ROW'
    }),
    addressRow() {
      this.getAddress(this.addressId)
        .then(resp => {
          this.address = resp
          if (this.address.endsWith(' ')) {
            this.address = this.address + '-'
          }
        })
        .catch(() => (this.address = this.addressId))
    }
  }
}
</script>

<style scoped></style>
